import React from 'react'
import StockRegisterCreate from '../../components/stockregistercomponents/StockRegisterCreate';

function StockRegisterCreatePage() {
    return (
        <>

            {/*Dynamic content goes here */}
            <StockRegisterCreate />

        </>
    )
}

export default StockRegisterCreatePage;